import React from 'react';
import { RouteConfig } from 'react-router-config';

import { PageRouteType, routePostProc } from '@/util/route';

const Exploration = React.lazy(
  () => import('@/page/app/experiment/exploration')
);

// const LogAnalysis = React.lazy(
//   () => import('@/page/app/experiment/loganalysis')
// );
// const LogDetail = React.lazy(
//   () => import('@/page/app/experiment/loganalysis/log-detail')
// );

// const Sandbox = React.lazy(() => import('@/page/app/system/toc-sandbox'));

const EXPERIMENT_ROUTE: RouteConfig[] = [
  {
    path: '/exploration',
    component: Exploration,
  },
  //   {
  //   path: '/loganalysis',
  //   exact: true,
  //   component: LogAnalysis,
  // },
  //   {
  //   path: '/loganalysis/detail',
  //   component: LogDetail,
  // },
  // {
  //   path: '/sandbox',
  //   component: Sandbox,
  // },
];

export { EXPERIMENT_ROUTE };
export default routePostProc(PageRouteType.EXPERIMENT, EXPERIMENT_ROUTE);
